import { getDefaultClient } from '../../../client/defaultClient';
import { fetchLegacyWalletBook } from '../fetchLegacyWalletBook';
import type { WalletConnectCatalog } from './getWalletConnectCatalog.types';
import { transformWalletBook } from './transformWalletBook';

/**
 * Retrieves the WalletConnect catalog from Dynamic's wallet book.
 *
 * This function fetches the wallet book and returns a WalletConnect catalog structure
 * that can be used for displaying wallet information and performing deep links for mobile wallet connections.
 *
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns A promise that resolves to the WalletConnect catalog containing groups and wallets.
 * @throws If unable to fetch the wallet book from the API (when both CDN fetch and cache retrieval fail).
 */
export const getWalletConnectCatalog = async (
  client = getDefaultClient()
): Promise<WalletConnectCatalog> => {
  const walletBook = await fetchLegacyWalletBook(client);

  return transformWalletBook({ walletBook });
};
